import { autoinject, Container } from "aurelia-dependency-injection";
import { BrowseView } from "../browse/views/browse";
import { BrowseModel } from "../browse/models/browse";
import { MasterView } from "../shared/views/master-view";

require("./styles/browse.less");

@autoinject
export class BrowseModule extends Backbone.Model {
    constructor(
        private browseView: BrowseView,
        public browseModel: BrowseModel,
        private masterView: MasterView) {
        super();
        this.setupViews();
    }

    public hide() {
         $("#viewport-content").removeClass("browse");
         $("#viewport-content").removeClass("browse-ready");
    }

    public show(parameters: string) {
        let params = [];
        this.showModule();

        if (parameters) {
            params = parameters.split("/").filter((item) => item.length > 0);
        } else {
            if (this.browseModel.Panels.length > 1) {
                this.browseModel.Panels.forEach((e) => {
                    if (e.Value) {
                        params.push(`${e.SelectedType}_${e.Value}`);
                    } else {
                        params.push(`${e.SelectedType}`);
                    }
                });
                const url = "browse/" + params.join("/");
                Backbone.history.navigate(url, {trigger: false});
                return;
            }
            else {
                Backbone.history.navigate("browse/material", {trigger: true});
                return;
            }
        }

        this.browseModel.setupPanels(params);
        this.browseView.panelsChanged();
    }

    public reset(): void {
       this.browseModel.Panels.remove(this.browseModel.Panels.rest(0));
    }

    private setupViews() {
        this.listenToOnce(this.masterView, "show", () => {
            const browseRegion = this.masterView.addRegion("browseRegion", "#browse-region");
            browseRegion.show(this.browseView);
        });
    }

    private showModule() {
        if (!$("#viewport-content").hasClass("browse")) {
            $("#viewport-content").addClass("browse");
            setTimeout(() => {
                $("#viewport-content").addClass("browse-ready");
            }, 820);
        } else {
            $("#viewport-content").addClass("browse-ready");
        }
        const newBrowseRegion = this.masterView.getRegion("browseRegion");
        const oldBrowseRegion = this.masterView.getRegion("oldBrowseRegion");
        $(newBrowseRegion.el).show();
        if (newBrowseRegion.el) {
            this.browseView.$el.show();
            $(newBrowseRegion.el).removeClass("vanish");
            $(oldBrowseRegion.el).hide();
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/browse/browse-module.ts